import { useGetWorkspacesApiV1Suspense } from "@/api/__generated__/api.schema";
import { routes } from "@/constants/url";
import { Loading } from "@backpac/monica";
import { Suspense } from "react";
import { Navigate, useLocation } from "react-router";

export function CampaignNavigator() {
  return (
    <Suspense fallback={<Loading.FullHeight />}>
      <RedirectDefaultWorkspace />
    </Suspense>
  );
}

function RedirectDefaultWorkspace() {
  const {
    data: {
      data: { items: workspaces },
    },
  } = useGetWorkspacesApiV1Suspense();

  if (workspaces.length === 0) {
    // NOTE: Bad access
    return <Navigate to={routes.NOT_FOUND.root} replace />;
  }
  const workspaceId = workspaces[0].id;
  const { pathname } = useLocation();

  return <Navigate to={`/workspaces/${workspaceId}${pathname}`} replace />;
}
